/**
This tooltip module is designed to work only .lendingtree.com domain. For other domain, please disable the same.
*/
<template>
    <span>
        <a class="zip-trigger" @click="ShowModal = true">Change Location</a>
        <modal v-if="ShowModal" class="zip-code-modal" @close="reset">
            <div slot="body">
                <h3 class="title">Change Location</h3>
                <div class="form">
                    <label>{{ headingText }}</label>
                    <zip-code-input
                        v-model="ZipCode"
                        :autofocus="true"
                        @input="getLocationByZip"
                        @enter="submitZip"
                    />
                    <div>
                        <span v-show="ShowZipCodeError" class="error-msg">Please enter a valid zip code.</span>
                    </div>
                    <button class="btn btn-blue" :disabled="ShowZipCodeError" @click="submitZip(ZipCode)">{{ SubmitBtnText }}</button>
                    <a v-if="showCancelButton" class="btn btn-cancel" @click="closeModal()">Cancel</a>
                </div>
            </div>
        </modal>
    </span>
</template>

<script>
    import Modal from '~/components/modal.vue';
    import ZipCodeInput from '~/components/zip-code-input.vue';
    import GetLocation from '~/mixin/get-geo-location';
    import StringFormat from '~/helpers/string-format';

    export default {
        props: {
            locationData: {
                type: Object,
                default() {
                    return {
                        zipCode: '',
                        city: '',
                        state: '',
                    };
                },
            },
            submitBtnText: {
                default: 'Update My Rates',
            },
            headingText: {
                default: 'Please enter your zip code:',
            },
            showCancelButton: {
                default: false,
            },

        },
        activated() {
            this.getLocationByZip();
        },
        data() {
            return {
                ZipCode: this.locationData.zipCode,
                TempLocData: this.locationData,
                LocationData: this.locationData,
                ShowZipCodeError: false,
                ShowModal: false,
                SubmitBtnText: this.submitBtnText,
            };
        },
        components: {
            ZipCodeInput,
            Modal,
        },
        mixins: [GetLocation],
        methods: {
            reset() {
                this.ZipCode = this.LocationData.zipCode;
                this.TempLocData = this.LocationData;
                this.ShowZipCodeError = false;
                this.ShowModal = false;
            },
            submitZip(zip) {
                this.getLocationByZip();
                if (this.zipCodeValidator()) {
                    this.ZipCode = zip;
                    this.ShowZipCodeError = false;
                    this.LocationData = this.TempLocData;
                    this.updateLocation(this.LocationData);
                    this.ShowModal = false;
                    this.$emit('submitZip', this.LocationData);
                } else {
                    this.ShowZipCodeError = true;
                }
            },
            updateLocation(val) {
                val.city = val.city.toLowerCase();
                val.city = StringFormat.capitalize(val.city);
            },
            getLocationByZip() {
                if (this.zipCodeValidator()) {
                    GetLocation.methods.GetZipCode(this.ZipCode, this.checkLocationResponse);
                }
            },
            checkLocationResponse(val) {
                if (!val.err) {
                    this.TempLocData = val;
                    this.ShowZipCodeError = false;
                } else {
                    this.ShowZipCodeError = true;
                }
            },
            zipCodeValidator() {
                const zipCodeRegEx = /^\d{5}$/;
                return zipCodeRegEx.test(this.ZipCode) && this.ZipCode !== '';
            },
            closeModal() {
                this.ShowModal = false;
            },
        },
        watch: {
            locationData(newValue, old) {
                this.ZipCode = newValue.zipCode;
            },
        },
    };
</script>

<style lang="scss">
@import "../../../assets/styles/variables";

#lt-yantr {

    .zip-code-modal {

        .modal-wrapper {
            max-width: 500px;
            top: 20%;

            @media #{$mob-landscape-view} {
                top: 0;
            }
        }

        .form {

            label {
                font-weight: 400;
                line-height: normal;
                display: block;
                margin-bottom: 15px;
            }

            input {
                margin-bottom: 10px;
            }

            .btn {
                margin: 10px 0;

                @media #{$mob-landscape-view} {
                    margin-bottom: 0;
                }
            }
        }
    }
}
</style>
